import ParameterErrors from '../errors/ParameterErrors';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
import SiteJsonUnitBirdsEyeView from './SiteJsonUnitBirdsEyeView';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnitBirdsEyeViews{
	constructor(props){
		const {list}=props;
		this._list = list;
		this.getMarkerPositionForBirdsEyeViewWithAngle= this.getMarkerPositionForBirdsEyeViewWithAngle.bind(this);
		this.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithIndex= this.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithIndex.bind(this);
		this.toJSON=this.toJSON.bind(this);
	}
	getMarkerPositionForBirdsEyeViewWithAngle(angle){
		const birdsEyeViewsWithIndex = this._list.filter(birdsEyeView=>{
			return birdsEyeView.angle===angle;
		});
		return birdsEyeViewsWithIndex.length>0?birdsEyeViewsWithIndex[0].markerPosition:null; 
	}
	getBirdsEyeViewMarkerPositionForBirdsEyeViewWithIndex(index){
		const birdsEyeViewWithIndex = this._list[index];
		return birdsEyeViewWithIndex?birdsEyeViewWithIndex.markerPosition:null; 
	}
	toJSON(){
		throw new Error('Not implemented');
	}
	static fromJSON(jArray){
		const list = jArray.map(jObject=>SiteJsonUnitBirdsEyeView.fromJSON(jObject));
		return new SiteJsonUnitBirdsEyeViews({
			list:list
		});
	}
	
}